import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Form, Formik, Field } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { CustomDiv } from "../chat-bot/style";
import ReferenceBackgroundImage from "../../assets/images/ReferenceBackgroundImage.svg";
import { CustomizeSpan, ErrorContent } from "../jobs/style";
import { CommonGrid2 } from "../common-components/StyledComponents";
import { StyledToggleButtonGroup } from "./styles";
import CommonButton from "../../component/Button";
import { useLocation, useParams } from "react-router-dom";
import SnackBar from "../../component/SnackBar";
import { GetReferenceCheck, PostReferenceCheck } from "../../redux/action/Job";
import { HandleSkeletion } from "../../utils/constants";
import SubmissionTickIco from "../../assets/icons/SubmissionTickIco";
import CommonTextField from "../../component/Input";
import { GetWhiteLabelAvatar } from "../common-components/CoverSheetFunction";
import { platformWhiteLogo } from "../../utils/logo";

export default function ReferenceCheckDetails() {
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [isLoading, setIsLoading] = useState({
    loading: false,
    buttonLoading: false,
    submission: false,
  });
  const param = useParams();
  const coversheetId = param.id;
  const lg = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const [initialValues, setInitialValues] = useState({
    data: ["Excellent", "Good", "Average", "Below Average"],
    candidate_name: "",
    reference_email: "",
    job_details: {
      company_name: "",
      job_title: "",
    },
    questions: [],
    org_label: "",
    org_logo_url: ""
  });

  const validationSchema = Yup.object({
    reference_email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    questions: Yup.array().of(
      Yup.object({
        question: Yup.string().required(),
        answer: Yup.string().required("Answer is required"),
      })
    ),
  });

  const handleFetchCall = async () => {
    setIsLoading((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      const response = await GetReferenceCheck(coversheetId);
      setInitialValues((prev) => ({
        ...prev,
        ...response,
        questions: response.questions.map((item) => {
          return {
            question: item,
            answer: "",
          };
        }),
      }));
      setIsLoading((prev) => ({
        ...prev,
        loading: false,
      }));
    } catch (error) {
      setIsLoading((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState((prev) => ({
        ...prev,
        open: true,
        message: error.message,
        severity: "error",
      }));
    }
  };

  useEffect(() => {
    handleFetchCall();
  }, []);

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleSubmit = async (values) => {
    setIsLoading((prev) => ({
      ...prev,
      buttonLoading: true,
    }));
    try {
      let payload = {
        questions: values.questions,
        reference_email: values.reference_email,
      };
      const response = await PostReferenceCheck(coversheetId, payload);
      setIsLoading((prev) => ({
        ...prev,
        buttonLoading: false,
        submission: true,
      }));
    } catch (error) {
      setIsLoading((prev) => ({
        ...prev,
        buttonLoading: false,
      }));
      setSnackbarState((prev) => ({
        ...prev,
        open: true,
        message: error.message,
        severity: "error",
      }));
    }
  };
  return (
    <CustomDiv>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values, actions) => {
          handleSubmit(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          form,
          validateForm,
        }) => {
          return (
            <Form
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
              }}
            >
              <CustomDiv
                sx={{
                  backgroundImage: `url(${ReferenceBackgroundImage})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
                boxShadow="1px 1px 5px 3px rgb(16 24 40 / 13%)"
                padding="2rem"
              >
                {initialValues?.org_label || (initialValues?.org_logo_url && typeof initialValues?.org_logo_url === 'string') ? 
                  (
                    GetWhiteLabelAvatar(initialValues.org_logo_url, initialValues.org_label, lg)
                  ):(
                    platformWhiteLogo({width: "160px", height: "55px"})
                  )
                }
                <CommonGrid2
                  display={"flex"}
                  flexDirection={"column"}
                  justifyContent={"center"}
                  color={"#fff"}
                  textAlign={"center"}
                  margin={"2rem 0px 4rem"}
                >
                  <Typography
                    variant="h2"
                    color="#D5DADD"
                    textAlign={"center"}
                    fontWeight={400}
                  >
                    Hi{" "}
                    {/* <CustomizeSpan color="#FA4F96" fontWeight={700}>
                      Zack!
                    </CustomizeSpan> */}
                  </Typography>
                  <Typography
                    variant="h2"
                    color="#D5DADD"
                    textAlign={"center"}
                    marginTop={"4px"}
                    fontWeight={400}
                  >
                    Are you open to filling a short reference check form for
                  </Typography>
                  {isLoading.loading ? (
                    <HandleSkeletion
                      height={50}
                      width={"400px"}
                      background="rgb(255 255 255 / 33%)"
                      margin={"10px auto 0px"}
                    />
                  ) : (
                    <Typography
                      variant="h1"
                      fontSize={"45px"}
                      color="#FFFFFF"
                      marginTop={"1rem"}
                      fontWeight={700}
                    >
                      {values.candidate_name}
                    </Typography>
                  )}
                  <CommonGrid2
                    display={"flex"}
                    flexDirection={"column"}
                    gap={"5px"}
                    marginTop={"1rem"}
                    // textAlign={"center"}
                  >
                    <Typography variant="subtitle1">Job Title</Typography>
                    {isLoading.loading ? (
                      <HandleSkeletion
                        height={80}
                        width={"300px"}
                        background="rgb(255 255 255 / 33%)"
                        margin={"auto"}
                      />
                    ) : (
                      <Typography
                        variant="h3"
                        color="#fff"
                        fontWeight={700}
                        textTransform={"capitalize"}
                      >
                        {values.job_details.job_title}
                      </Typography>
                    )}
                  </CommonGrid2>
                  {isLoading.submission && (
                    <CommonGrid2
                      justifyContent={"center"}
                      display={"flex"}
                      marginTop={"1rem"}
                    >
                      <CommonGrid2
                        width={"max-content"}
                        justifyContent={"center"}
                        display={"flex"}
                        alignItems={"center"}
                        gap="10px"
                        background="#079455"
                        padding={"10px"}
                        borderRadius={"8px"}
                      >
                        <SubmissionTickIco />
                        <Typography variant="h5" color="#fff">
                          Submission Successful
                        </Typography>
                      </CommonGrid2>
                    </CommonGrid2>
                  )}
                </CommonGrid2>
              </CustomDiv>
              {!isLoading.submission && (
                <CommonGrid2
                  width={{
                    xs: "95%",
                    sm: "90%",
                    md: "80%",
                  }}
                  margin={"auto"}
                  marginTop={"2rem"}
                >
                  {/* <Typography variant="body5" fontWeight={700}>
                  About the Role:
                </Typography>
                <Typography variant="h6" fontWeight={500}>
                   We are looking for a Senior Java Developer to craft
                  intuitive, engaging, and scalable user experiences. You will
                  work closely with product managers, engineers, and
                  stakeholders to transform complex problems into elegant
                  solutions
                </Typography>{" "} */}
                  <CommonGrid2 container spacing={2}>
                    <CommonGrid2
                      display="flex"
                      flexDirection="column"
                      gap="10px"
                      item
                      size={{ xs: 12, sm: 6 }}
                    >
                      <Typography variant="h6">Reference Email</Typography>
                      <Field name={"reference_email"}>
                        {({ field, form }) => {
                          return (
                            <CommonTextField
                              placeholder={"Enter the Reference Email"}
                              padding="10px"
                              error={Boolean(form.errors["reference_email"])}
                              value={values.reference_email}
                              onChange={(e) => {
                                setFieldValue(
                                  "reference_email",
                                  e.target.value
                                );
                              }}
                              helperText={form.errors["reference_email"]}
                            />
                          );
                        }}
                      </Field>
                    </CommonGrid2>
                  </CommonGrid2>
                  <CustomDiv margin="2rem 0px 1rem">
                    <Typography variant="h2" color="#101828" fontWeight={700}>
                      Questions about{" "}
                      {!isLoading.loading && (
                        <CustomizeSpan color="#7F56D9" fontWeight={700}>
                          {values.candidate_name}
                        </CustomizeSpan>
                      )}
                    </Typography>
                    <Typography variant="h6" marginTop={"5px"}>
                      Please answer the questions below.
                    </Typography>
                  </CustomDiv>
                  <CommonGrid2
                    display={"flex"}
                    flexDirection={"column  "}
                    gap={"2rem"}
                  >
                    {isLoading.loading
                      ? Array.from({ length: 3 }).map((_, index) => (
                          <HandleSkeletion key={index} height={80} />
                        ))
                      : values.questions.map((item, index) => (
                          <CommonGrid2>
                            <Typography variant="h6">
                              <CustomizeSpan>
                                {index + 1}
                                {".  "}
                              </CustomizeSpan>
                              {item.question}{" "}
                              <CustomizeSpan color={"red"}> *</CustomizeSpan>
                            </Typography>
                            <StyledToggleButtonGroup
                              value={item.answer}
                              exclusive
                              onChange={(e, newValue) => {
                                if (newValue !== null) {
                                  setFieldValue(
                                    `questions.${index}.answer`,
                                    newValue
                                  );
                                }
                              }}
                              error={Boolean(
                                touched.questions?.[index]?.answer &&
                                  errors.questions?.[index]?.answer
                              )}
                            >
                              {values.data.map((item) => (
                                <ToggleButton value={item}>{item}</ToggleButton>
                              ))}
                            </StyledToggleButtonGroup>
                            {touched.questions?.[index]?.answer &&
                              errors.questions?.[index]?.answer && (
                                <ErrorContent>
                                  {errors.questions[index].answer}
                                </ErrorContent>
                              )}
                          </CommonGrid2>
                        ))}
                  </CommonGrid2>
                  <CommonButton
                    fontWeight={600}
                    marginTop={"1.5rem"}
                    value={"Submit & Proceed"}
                    padding={"10px 1.5rem"}
                    type="submit"
                    disabled={isLoading.buttonLoading}
                    loading={isLoading.buttonLoading}
                  />
                </CommonGrid2>
              )}
            </Form>
          );
        }}
      </Formik>
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </CustomDiv>
  );
}
